import { theme, Typography } from "kosmos-ui/lib";

import {
  ChangelogContainer,
  SubheaderContainer,
  Subheader,
  SubSubheader,
  Paragraph,
  Chip,
  Li,
  Ul,
} from "./styles";

export default function ChangelogSection() {
  return (
    <ChangelogContainer>
      <Typography
        as="h1"
        variant="title1"
        style={{
          color: theme.colorsPalette.white.default,
          maxWidth: 620,
          textAlign: "center",
        }}
      >
        Changelog
      </Typography>

      <Typography
        variant="paragraph1"
        style={{ maxWidth: 620, textAlign: "center" }}
      >
        Actualizaciones y mejoras a nuestra plataforma.
      </Typography>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>10 Dic 2021</Subheader>

        <Chip>v1.0.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Grafito Community</SubSubheader>

      <Paragraph>
        Con este gran lanzamiento oficializamos nuestra primera versión de
        Grafito! Este es nuestro primer paso para formar nuestra comunidad.
      </Paragraph>

      <Paragraph>
        Hemos unificado todas nuestras marcas en un solo lugar para que
        descubras sus excelentes productos e ideas de manera mucho más fácil,
        rápida y cómoda. Encuentra todas tus marcas, categorías y productos en
        un solo lugar.
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>17 Oct 2021</Subheader>

        <Chip>v0.24.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Reporte de ventas exportable</SubSubheader>

      <Paragraph>
        En esta nueva versión de Grafito, hemos incluido la posibilidad de que
        como marca, exportes tus ventas desde la plataforma.
      </Paragraph>

      <SubSubheader>Barra de anuncios importantes</SubSubheader>

      <Paragraph>
        Como marca, ahora podrás resaltar contenido interesante para tus
        clientes en tu tienda virtual. Elige tu contenido y personalizalo con
        tus colores y estilos!
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>28 Jul 2021</Subheader>

        <Chip>v0.22.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Sesión de usuario multi-tienda</SubSubheader>

      <Paragraph>
        Ahora es posible que te registres e inicies sesión en nuestra
        plataforma, para que puedas recibir recomendaciones inteligentes de tus
        marcas y productos favoritos, tus compras, y puedas tener una
        experiencia de compra mucho mejor.
      </Paragraph>

      <Paragraph>
        Con esta versión de nuestra plataforma, te permitimos navegar con una
        misma sesión dentro de todas nuestras tiendas virtuales. Adicionalmente,
        te mantenemos informado de las últimas novedades, nuevas marcas y nuevos
        productos que seguramente amarás.
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>13 Jul 2021</Subheader>

        <Chip>v0.21.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Exportar productos y órdenes</SubSubheader>

      <Paragraph>
        Ahora es posible exportar en formato Excel, todos tus productos y
        órdenes de compra desde el backoffice.
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>30 Jun 2021</Subheader>

        <Chip>v0.20.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Texto enriquecido en tu tienda virtual</SubSubheader>

      <Paragraph>
        En esta nueva versión de Grafito, podrás ver descripciones mucho más
        completas de tus productos favoritos. Hemos permitido agregar imágenes,
        listas, negritas, títulos, entre otros.
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>08 Jun 2021</Subheader>

        <Chip>v0.19.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Marcas de productos</SubSubheader>

      <Paragraph>
        Hemos introducido la posibilidad de que dentro de tu tienda virtual, tus
        productos puedan pertenecer a múltiples marcas.
      </Paragraph>

      <Paragraph>
        Esto significa, poder clasificarlos no solo por categoría, sino que
        también por marca.
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>18 May 2021</Subheader>

        <Chip>v0.18.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Búsqueda y paginación de productos</SubSubheader>

      <Paragraph>
        En esta versión de Grafito, le permitimos a las marcas manejar de manera
        mucho más cómoda sus productos en sus backoffices. Ahora es posible
        buscar productos y cargarlos en la medida que se necesitan.
      </Paragraph>

      <Paragraph>
        De la misma manera, ahora podrás buscar tus productos en tus tiendas
        virtuales, pudiendo así acceder rápidamente a ellos.
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>13 Abr 2021</Subheader>

        <Chip>v0.17.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Orden de imágenes de productos</SubSubheader>

      <Paragraph>
        A través de esta nueva funcionalidad, podrás ordenar como tú quieras
        todas las imágenes de tus productos.
      </Paragraph>

      <Paragraph>
        Desarrollamos una interfaz sumamente sencilla y cool para que configures
        a tu gusto el orden en el que tus clientes ven tus productos.
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>9 Mar 2021</Subheader>

        <Chip>v0.16.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Carga masiva de productos</SubSubheader>

      <Paragraph>
        En esta nueva versión de la plataforma agregamos la funcionalidad de
        cargar masivamente distintos tipos de productos de una sola vez.
      </Paragraph>

      <Paragraph>
        Esto ahora es posible cargando un archivo CSV desde el backoffice de la
        plataforma, dentro del cual puedes listar en filas todos los productos
        que quieres agregar, detallando su nombre, categoría, precio, stock,
        descripción, entre otros. La planilla de ejemplo también la puedes
        descargar desde el backoffice!
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>15 Feb 2021</Subheader>

        <Chip>v0.15.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Slideshows personalizadas</SubSubheader>

      <Paragraph>
        Hemos agregado la posibilidad de que puedas incorporar al homepage de tu
        tienda virtual <i>Slideshows</i> personalizadas. Esto significa, una
        sección de varias imagenes con títulos, subtitulos y links las cuales
        van cambiando cada cierta cantidad de tiempo.
      </Paragraph>

      <Paragraph>
        Especial para publicar tus promociones, nuevos productos o cualquier
        tipo de noticia para tus seguidores.
      </Paragraph>

      <Paragraph>
        Es posible configurar la altura del slideshow, la opacidad del velo
        negro que se utiliza para remarcar el texto y la rapidez con la que cada
        slide va pasando a la siguiente.
      </Paragraph>

      <SubSubheader>Mejoras</SubSubheader>

      <Paragraph>
        Mejoramos la forma en la que se muestra el resumen de tus ventas,
        evolución de clientes, órdenes y ventas por localización en el dashboard
        de la plataforma.
      </Paragraph>

      <Paragraph>
        Ahora podrás visualizar la información más facilmente y aplicar filtros
        de tiempo sobre las estadísticas.
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>25 Ene 2021</Subheader>

        <Chip>v0.14.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Opción de retiro en tienda</SubSubheader>

      <Paragraph>
        Ahora tus clientes podrán elegir si quieren despacho a domicilio o
        retiro en tienda a la hora de comprar tus productos en tu tienda
        virtual.
      </Paragraph>

      <Paragraph>
        Esta nueva modalidad puede activarse o desactivarse fácilmente desde el
        backoffice de la plataforma. Todas las órdenes de clientes ahora llevan
        la especificación de si deben despacharse a domicilio o el cliente las
        retirará en tu tienda.
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>7 Ene 2021</Subheader>

        <Chip>v0.13.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Cupones de descuento</SubSubheader>

      <Paragraph>
        A través de esta nueva funcionalidad puedes entregarle a tus seguidores
        cupones que a la hora de comprar en tu tienda virtual, pueden activar
        para obtener descuentos personalizados en sus compras.
      </Paragraph>

      <Paragraph>
        Puedes generar cuantos cupones quieras, agregarles descuentos
        específicos (montos fijos de descuento o porcentajes sobre el total de
        la compra), limitar el número de usos y fijar una fecha de caducación.
        Todo de manera fácil e intuitiva desde tu backoffice.
      </Paragraph>

      <SubSubheader>Mejoras</SubSubheader>

      <Paragraph>
        Resolvimos problema relacionado a la no lectura de zonas y
        localizaciones de delivery cuando clientes no especificaban el lugar de
        envío al comprar.
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>14 Dic 2020</Subheader>

        <Chip>v0.12.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Blogs y galerías en tienda virtual</SubSubheader>

      <Paragraph>
        Con esta nueva funcionalidad es posible crear páginas personalizadas de
        tipo <i>blog</i> o <i>galería</i> de imágenes, a las cuales tus clientes
        podrán entrar desde tu tienda virtual.
      </Paragraph>

      <Paragraph>
        Llamamos <i>Blogs</i> a una página donde puedes redactar cualquier tipo
        de actículo, pudiendo agregar imágenes, títulos, subtítulos, citas,
        entre otros. Por otra parte, a través de <i>Galerías</i>, podrás
        publicar fotos (eventos, noticias, productos destacados, entre otros) en
        un formato lindo y atrativo para que tus seguidores vean en tu tienda
        virtual.
      </Paragraph>

      <SubSubheader>Mejoras</SubSubheader>

      <Paragraph>
        Resolvimos un problema detectado a la hora de mostrar el stock total de
        un producto en la lista de productos, cuando este consta de múltiples
        variantes, cada una con un stock diferente.
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>14 Dic 2020</Subheader>

        <Chip>v0.11.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Volumen de productos</SubSubheader>

      <Paragraph>
        Agregamos la opción de especificar la altura, largo, ancho y peso de
        cada uno de tus productos, de tal manera de que tengas una definición de
        producto más detallada y una forma mucho mas exacta de calcular sus
        costos de envíos.
      </Paragraph>

      <SubSubheader>Mejoras</SubSubheader>

      <Ul>
        <Li>
          Hicimos una serie de mejoras en el performance de la carga de órdenes
          de tus clientes, de manera que ahora se cargarán y podrás gestionarlas
          mucho más rápido.
        </Li>

        <Li>
          Se solucionó problema detectado al actualizar links de navegación y
          que los cambios no se reflejaran automáticamente en el backoffice,
          sino que hubiera que re cargar la app para verlos.
        </Li>
      </Ul>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>1 Dic 2020</Subheader>

        <Chip>v0.10.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Posicionamiento de links de navegación</SubSubheader>

      <Paragraph>
        Agregamos la posibilidad de posicionar los links de navegación de tu
        tienda virtual en el orden que tú quieras.
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>26 Nov 2020</Subheader>

        <Chip>v0.9.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Links de navegación</SubSubheader>

      <Paragraph>
        En esta nueva versión de Grafito.app hemos incluido la posibilidad de tú
        mism@ crear los menús de navegación de tu tienda virtual. De esta forma,
        podrás personalizar mucho mejor la forma en la que tus seguidores
        visitan tu tienda virtual, permitiendote clasificar de mejor manera tus
        categorías y subcategorías, resaltar contenido específico de tu marca y
        mejorar la experiencia en la que tus clientes navegan por tu tienda.
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>25 Nov 2020</Subheader>

        <Chip>v0.8.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Imagenes en páginas personalizadas</SubSubheader>

      <Paragraph>
        Incluimos la opción de insertar imagenes en las páginas personalizadas
        de tu tienda virtual. Podrás agregar múltiples imagenes dentro de tu
        contenido para hacerlo más nutritivo para tus seguidores!
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>16 Nov 2020</Subheader>

        <Chip>v0.7.0</Chip>
      </SubheaderContainer>

      <SubSubheader>
        Orientación de barra de navegación de tienda virtual
      </SubSubheader>

      <Paragraph>
        En esta versión de Grafit.app incluimos la posibilidad de que puedas
        configurar la barra de navegación para que se muestre horizontal o
        verticalmente, de tal manera de ofrecer una forma <i>minimalista</i> y
        otra más explícita de mostrar sus links de categorías.
      </Paragraph>

      <SubSubheader>Mejoras</SubSubheader>

      <Paragraph>
        Hicimos múltiples mejoras en el manejo de descuentos por producto y por
        variante.
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>31 Oct 2020</Subheader>

        <Chip>v0.6.0</Chip>
      </SubheaderContainer>

      <SubSubheader>
        Firma automática de términos y condiciones de uso
      </SubSubheader>

      <Paragraph>
        Hemos encapsulado en un solo documento todos nuestros términos y
        condiciones de uso de la plataforma, lo cuales pueden ser aceptados
        dígitalmente en tu backoffice. Esto permite que nuestras marcas puedan
        incorporarse mucho más rápido con nosotros y los libera de documentación
        innecesaria.
      </Paragraph>

      <SubSubheader>Mejoras</SubSubheader>

      <Paragraph>
        Hicimos mucho mas fácil e intuitivo el proceso de crear o actualizar
        productos y sus variantes. Removimos algunos procesos innecesarios del
        lado del usuario e hicimos el flujo de trabajo mucho más expedito.
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>26 Oct 2020</Subheader>

        <Chip>v0.5.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Precio y SKU por variante de producto</SubSubheader>

      <Paragraph>
        Ahora cada variante de producto puede llevar su propio precio y SKU,
        independientemente del producto al que pertenezca.
      </Paragraph>

      <Paragraph>
        Esto te proveerá de mucha más flexibilidad a la hora de crear y
        clasificar tus productos, como así también una mejor experiencia de
        usuario para tus seguidores a la hora de escojer tus productos.
      </Paragraph>

      <SubSubheader>Mejoras</SubSubheader>

      <Ul>
        <Li>
          Definimos como criterio de orden automático para listar a tus
          seguidores, la fecha de su última interacción con tu marca (compra en
          este caso).
        </Li>

        <Li>
          Incluimos los campos opcionales de teléfono y RUT para tus seguidores.
        </Li>

        <Li>
          Resolvimos algunos problemas visuales a la hora de visualizar el
          listado de categorías de productos desde dispositivos pequeños.
        </Li>
      </Ul>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>28 Sept 2020</Subheader>

        <Chip>v0.4.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Manejo de estados de órdenes</SubSubheader>

      <Paragraph>
        Hemos incluido una funcionalidad muy importante para nuestras marcas: la
        posibilidad de que manejes el ciclo de vida de tus órdenes y de que tus
        clientes se mantengan informados en tiempo real de los cambios de las
        mismas.
      </Paragraph>

      <Paragraph>
        Esto significa, que ahora puedes gestionar el estado de tus ordenes
        (recibida, en preparación, en despacho, despachada, cancelada) y
        nosotros nos encargamos de que tus clientes se mantengan al tanto de
        cada movimiento.
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>27 Ago 2020</Subheader>

        <Chip>v0.3.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Rediseño de UI/UX</SubSubheader>

      <Paragraph>
        Realizamos importantes mejoras en el diseño de la plataforma, tanto para
        tu backoffice como tienda virtual. Hemos introducido un completo y nuevo
        diseño de interfaz, el cual entregará a ti y a tus seguidores una
        experiencia totalmente intuitiva, fresca y agradable de utilizar.
      </Paragraph>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>24 Ago 2020</Subheader>

        <Chip>v0.2.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Notas personalizadas para el checkout</SubSubheader>

      <Paragraph>
        En esta versión introducimos la posibilidad de que puedas agregar notas,
        cualquiera sea el anuncio que quieras dar, para tus clientes en el
        checkout de su compra.
      </Paragraph>

      <Paragraph>
        Simplemente agrega el texto desde tu backoffice y tus clientes lo verán
        al momento de estar en el checkout de su compra.
      </Paragraph>

      <SubSubheader>Mejoras</SubSubheader>

      <Ul>
        <Li>
          Resolvimos un error relacionado con el manejo de estados (activa o
          desactiva) de categorías de productos. Previamente la acción de
          cambiar el estado no se estaba reflejando en la tienda virtual, con
          las mejoras incorporadas la funcionalidad volvió a la normalidad.
        </Li>

        <Li>
          Mejoramos la el proceso de creación de productos, de manera que la
          plataforma automáticamente refresca la lista de productos luego de que
          estos son creados.
        </Li>
      </Ul>

      <SubheaderContainer>
        <Subheader style={{ marginTop: 16 }}>14 Jul 2020</Subheader>

        <Chip>v0.1.0</Chip>
      </SubheaderContainer>

      <SubSubheader>Lanzamiento de nuestra plataforma</SubSubheader>

      <Paragraph>
        Grafito.app lanza su primera versión al público. En esta primera versión
        incluimos múltiples funcionalidades fundamentales para nuestras marcas,
        dentro de las que se destacan: gestión de productos e inventario,
        gestión de órdenes y pagos, gestión de clientes, estadísticas básicas de
        ventas y una tienda virtual 100% administrable para que tus seguidores
        puedan conocer tu marca y comprar tus productos.
      </Paragraph>

      <Paragraph>
        La plataforma está compuesta por dos aplicaciones, un backoffice y una
        tienda online con dominio personalizado para cada una de nuestras marcas
        (con carrito de compra y proceso de pago incorporados).
      </Paragraph>
    </ChangelogContainer>
  );
}
